import { useState, useEffect, useRef, Fragment, memo, useMemo, useContext, useCallback } from "react";
import style from "./../index.module.scss";
import styleUi from "./EventDetail.module.scss";
import { CSSTransition } from 'react-transition-group';
import AppConfig from '../../AppConfig';
import { CustomEventManager } from "../../comm/global/CustomEventManager";
import MapRoute from "./MapRoute";
import Popover from '@mui/material/Popover';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import * as YStyled from '../../Styleds';
import SelRewildingMode from "../../comm/global/components/SelRewildingMode";
import DateTimeSel from "../../comm/global/components/DateTimeSel";
import MemberLimit from "../../comm/global/components/MemberLimit";
import MeetPoint from "../../comm/global/components/MeetPoint";
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import WeatherWidget from "../../comm/global/components/WeatherWidget";
import FriendInfo from "../../comm/global/components/FriendInfo";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SubMenuAndContent from "./SubMenuAndContent";
import apiManager from './../../ApiManager';
import { GameContext } from "../../GameContext";
import CheckIcon from '@mui/icons-material/Check';
const customEventManager = new CustomEventManager();
const EventDetail = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [isPast, set_isPast] = useState(false);
    const [isSetting, set_isSetting] = useState(false);
    const [photo, set_photo] = useState("");
    const [meetPlace, set_meetPlace] = useState({ name: "", lat: "", lng: "" });
    const [data, set_data] = useState();
    const [participants, set_participants] = useState([]);
    const { userData, preProcessEvent } = useContext(GameContext);
    useEffect(() => {
        console.log("......", arg.vo)
        set_data(arg.vo);
        set_meetPlace({
            name: arg.vo.events_meeting_point_name,
            "lat": arg.vo.events_meeting_point_lat,
            "lng": arg.vo.events_meeting_point_lng
        }
        );
        const now = new Date();
        if (arg.vo.events_date_end < now)
            set_isPast(true);
        if (userData)
            updateParticipants();
        setInProp(true);
        set_photo(arg.vo.events_photo);
        customEventManager.addEventListener("selPot", selPot);
        return () => {
            customEventManager.removeEventListener("selPot", selPot);
        }
    }, [])

    useEffect(() => {
        if (meetPlace) {
            set_data(prev => {
                const data = { ...prev };
                data.events_meeting_point_lat = meetPlace.lat;
                data.events_meeting_point_lng = meetPlace.lng;
                data.events_meeting_point_name = meetPlace.name;
                return data;
            })
        }
    }, [meetPlace]);
    function updateParticipants() {
        apiManager.fetchGet(`event/${arg.vo.events_id}/participants`, {}, 0).then(res => {
            set_participants(res);
            console.log("participants", res)
        })
    }

    const selPot = async (pot) => {
        //刪掉在此modal之後的所有modal
        addModalType({ cmd: "delAfter", cls: "EventDetail" });
        console.log("pot", pot)
        set_data(prev => { return { ...prev, events_rewilding: pot.rewilding_id, rewildingObj: { ...pot } } })
    }
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const imageUrl = URL.createObjectURL(file);
        set_photo(imageUrl);
        set_data(prev => { return { ...prev, events_photo: file, events_photo_cove: "" } })
    };

    const participantsCount = () => {
        return participants.filter(v => v.event_participants_status_label === "ACCEPTED").length;
    }
    const getIdentity = () => {
        if (!userData)
            return { state: 3, label: "立即報名", disable: false };
        if (data.events_created_by === userData.users_id) {
            return { state: 0, label: "發送邀請", disable: false };
        }
        else {
            const findParticipant = participants.find(v => v.event_participants_user === userData.users_id);
            console.log("findParticipant", findParticipant)
            if (findParticipant) {
                if (findParticipant.event_participants_status_label === "ACCEPTED")
                    return { state: 1, label: "已加入", disable: true };
                else if (findParticipant.event_participants_status_label === "PENDING")
                    return { state: 2, label: "加入", disable: (data.events_participant_limit > 0 && participantsCount() >= data.events_participant_limit) };
                else if (findParticipant.event_participants_status_label === "APPLIED")
                    return { state: 3, label: "已報名", disable: true };
                else if (findParticipant.event_participants_status_label === "REJECTED")
                    return { state: 4, label: "已拒絕", disable: true };
            }
            else
                return {
                    state: 3, label: `立即報名`,
                    disable: (data.events_participant_limit > 0 && participantsCount() >= data.events_participant_limit)
                };
        }
    }
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "EventDetail"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                            }
                        }}>
                            {data &&
                                <div className={styleUi.app}>
                                    <div className={styleUi.header}>
                                        <img src="./assets/ui/back.png" onClick={e => {
                                            arg.cb("back");
                                            setInProp(false)
                                        }} />
                                    </div>
                                    <YStyled.BackgroundDiv className={styleUi.photo} img={photo}>
                                        {isSetting &&
                                            <label className={styleUi.editBtn}>
                                                <img src="./assets/ui/edit.png" />
                                                <YStyled.Span fontFamily="SF Pro" fontWeight={400} size={13} >編輯</YStyled.Span>
                                                <input type="file" accept="image/*" onChange={e => { handleFileChange(e) }} />
                                            </label>
                                        }
                                    </YStyled.BackgroundDiv>
                                    {isSetting === false ?
                                        <div className={styleUi.view} >
                                            <div className={styleUi.baseInfo}>
                                                <TitleBar addModalType={addModalType} data={data} identity={getIdentity()} userData={userData} participants={participants} isSetting={isSetting} set_isSetting={set_isSetting} setInProp={setInProp} />
                                                <YStyled.Row gap=".4rem" align="flex-start" style={{ marginTop: "1.2rem" }}>
                                                    <img src="./assets/ui/Calendar.png" />
                                                    <YStyled.Span fontFamily="SF Pro" fontWeight={400} size={13} >{`${data.events_date.formatYYYYMMDDHHMM()} - ${data.events_date_end.formatYYYYMMDDHHMM()}`}</YStyled.Span>
                                                </YStyled.Row>
                                                <YStyled.Row gap=".4rem" align="flex-start" style={{ marginTop: "0rem" }}>
                                                    <img src="./assets/ui/Profile.png" />
                                                    <YStyled.Span fontFamily="SF Pro" fontWeight={400} size={13} >{data.events_created_by_user.user_name}</YStyled.Span>
                                                    <img src="./assets/ui/radioSel.png" />
                                                    <YStyled.Span fontFamily="SF Pro" fontWeight={400} size={13}>
                                                        {`共${participantsCount()}人參加${data.events_participant_limit > 0 ? `・${data.events_participant_limit}人滿團` : ""}`}
                                                    </YStyled.Span>

                                                </YStyled.Row>
                                                {isPast === false &&
                                                    <YStyled.BTN3 disabled={getIdentity().disable} disableBg="#00000088" normalBg="black" normalColor="white" style={{ borderRadius: "12px", padding: ".8rem 1rem", marginTop: ".6rem" }} onClick={e => {
                                                        console.log("participants", participants)
                                                        if (!userData) {
                                                            window.location.href = AppConfig.registerUrl();
                                                            return;
                                                        }
                                                        switch (getIdentity().state) {
                                                            case 0://發送邀請
                                                                addModalType({
                                                                    cls: "SendInvite", arg: {
                                                                        vo: data,
                                                                        cb:()=>{
                                                                            updateParticipants();
                                                                        }
                                                                    }
                                                                })
                                                                break;
                                                            case 2://加入
                                                                apiManager.fetchGet(`event-invitations`, {}, 0).then(invitations => {
                                                                    console.log("invitations", invitations)
                                                                    const invitation = invitations.find(v => v.event_participants_event === arg.vo.events_id);
                                                                    if (invitation) {
                                                                        console.log("invitation", invitation.event_participants_id)
                                                                        apiManager.fetchPut(`event-invitations/${invitation.event_participants_id}`, { event_participants_status: 1 }, 0).then(res => {
                                                                            console.log("res", res);
                                                                            updateParticipants();
                                                                        });
                                                                    }
                                                                    else
                                                                        alert("找不到邀請記錄");

                                                                })
                                                                break;
                                                            case 3://加入
                                                                addModalType({
                                                                    cls: "Join",
                                                                    arg: {
                                                                        eventVo: data, cb: () => {
                                                                            updateParticipants();
                                                                        }
                                                                    },

                                                                });
                                                                break;
                                                        }
                                                    }}>
                                                        <YStyled.Row gap="2px">
                                                            {getIdentity().state === 1 &&
                                                                <CheckIcon />
                                                            }
                                                            <YStyled.Span fontWeight={700} size={17} >{getIdentity().label}</YStyled.Span>
                                                        </YStyled.Row>
                                                    </YStyled.BTN3>
                                                }
                                                <YStyled.Row style={{ marginTop: "1.4rem" }}>
                                                    <YStyled.Span size={17} >地點</YStyled.Span>
                                                </YStyled.Row>
                                                <YStyled.Label style={{ width: "100%", marginTop: ".6rem" }}>
                                                    <YStyled.Row gap=".8rem" align={"flex-start"}>
                                                        <img src='./assets/ui/postion.png' />
                                                        <YStyled.Col align={"flex-start"} gap={".4rem"}>
                                                            <YStyled.Span size={17}>{data.rewildingObj.rewilding_name}</YStyled.Span>
                                                            <YStyled.Span size={13} color={"#00000028"}>{data.rewildingObj.rewilding_location.join("")}</YStyled.Span>
                                                        </YStyled.Col>
                                                    </YStyled.Row>
                                                </YStyled.Label>
                                                <YStyled.Row style={{ margin: "1.4rem 0 1rem 0" }}>
                                                    <YStyled.Span size={17} >集合點</YStyled.Span>
                                                </YStyled.Row>
                                                <MeetPoint meetPlace={meetPlace} set_meetPlace={set_meetPlace} rewildingObj={data.rewildingObj} />
                                                <YStyled.RoundedDiv style={{ width: "100%", marginTop: "1rem", position: "relative" }}>
                                                    <MapRoute origin={meetPlace} destination={{ lat: data.rewildingObj.rewilding_lat, lng: data.rewildingObj.rewilding_lng }} showBtn={true} />
                                                </YStyled.RoundedDiv>
                                                <YStyled.Row style={{ margin: "1.4rem 0 1rem 0" }}>
                                                    <YStyled.Span size={17} >天氣預報</YStyled.Span>
                                                </YStyled.Row>
                                                <div className={styleUi.weather}>
                                                    <WeatherWidget cityId={data.events_city_id} />
                                                </div>
                                            </div>
                                            <SubMenuAndContent isSetting={isSetting} addModalType={addModalType} vo={data} participants={participants} />
                                        </div>
                                        :
                                        <div className={styleUi.settingView}>
                                            <YStyled.Row>
                                                <YStyled.Span size={22} color={"#454545"}>設定</YStyled.Span>
                                                <YStyled.BTN1 style={{ padding: ".2rem .6rem" }}>
                                                    <YStyled.Span size={17} onClick={e => {
                                                        console.log(data);
                                                        const putData = {
                                                            events_date: data.events_date.toISOString(),
                                                            events_date_end: data.events_date_end.toISOString(),
                                                            events_deadline: data.events_deadline.toISOString(),
                                                            events_lat: data.events_lat,
                                                            events_lng: data.events_lng,
                                                            events_meeting_point_lat: data.events_meeting_point_lat,
                                                            events_meeting_point_lng: data.events_meeting_point_lng,
                                                            events_meeting_point_name: data.events_meeting_point_name,
                                                            events_name: data.events_name,
                                                            events_photo: data.events_photo,
                                                            events_participant_limit: data.events_participant_limit,
                                                            events_payment_fee: data.events_payment_fee,
                                                            events_payment_required: data.events_payment_required,
                                                            events_place: data.events_place,
                                                            events_requires_approval: data.events_requires_approval,
                                                            events_rewilding: data.events_rewilding,
                                                            events_type: data.events_type,
                                                        }
                                                        var formdata = new FormData();
                                                        for (var k in putData) {
                                                            formdata.append(k, putData[k]);
                                                        }
                                                        formdata.forEach((value, key) => {
                                                            console.log(key + ': ' + value);
                                                        });
                                                        apiManager.fetchPutForm(`event/${data.events_id}`, formdata).then(res => {
                                                            console.log("res", res);
                                                            if (res.message)
                                                                alert(res.message)
                                                            else {
                                                                //todo
                                                                console.log("edit");
                                                                preProcessEvent(res).then(_event => {
                                                                    set_data(_event)
                                                                    if (arg.set_events) {
                                                                        console.log("edit", arg.set_events);
                                                                        arg.set_events(prev => {
                                                                            const _prev = [...prev];
                                                                            const index = _prev.findIndex(v => v.events_id === _event.events_id);
                                                                            if (index !== -1)
                                                                                _prev[index] = _event;
                                                                            return _prev;
                                                                        })
                                                                    }
                                                                })
                                                                set_isSetting(false);
                                                            }
                                                        }).catch(err => {
                                                            alert(err);
                                                        })

                                                    }}>儲存</YStyled.Span>
                                                </YStyled.BTN1>
                                            </YStyled.Row>
                                            <YStyled.Row style={{ marginTop: "1.4rem" }}>
                                                <YStyled.Span size={17} >行程名稱</YStyled.Span>
                                            </YStyled.Row>
                                            <YStyled.Label style={{ width: "100%", marginTop: ".6rem" }}>
                                                <YStyled.Input value={data.events_name} size={14} type="text" placeholder="劍潭山沒有潭也沒有劍" onChange={e => {
                                                    set_data(prev => { return { ...prev, events_name: e.target.value } })
                                                }} />
                                            </YStyled.Label>
                                            <YStyled.Row style={{ marginTop: "1.4rem" }}>
                                                <YStyled.Span size={17} >地點</YStyled.Span>
                                            </YStyled.Row>


                                            {data.rewildingObj.rewilding_name !== "" ?
                                                <YStyled.Label style={{ width: "100%", marginTop: ".6rem" }}>
                                                    <YStyled.Row gap=".8rem" align={"flex-start"}>
                                                        <img src='./assets/ui/postion.png' />
                                                        <YStyled.Col align={"flex-start"} gap={".4rem"}>
                                                            <YStyled.Span size={17}>{data.rewildingObj.rewilding_name}</YStyled.Span>
                                                            <YStyled.Span size={13} color={"#00000028"}>{data.rewildingObj.rewilding_location.join(" ")}</YStyled.Span>
                                                        </YStyled.Col>
                                                    </YStyled.Row>
                                                    <img src="./assets/ui/x.png" style={{ position: "absolute", top: "10%", right: "4%" }} onClick={e => {
                                                        set_data(prev => { return { ...prev, rewildingObj: { ...prev.rewildingObj, rewilding_name: "" } } })
                                                    }} />
                                                </YStyled.Label>
                                                :
                                                <YStyled.Label style={{ width: "100%", marginTop: ".6rem" }} onClick={e => {
                                                    addModalType({
                                                        cls: "SelectPot", arg: {
                                                            cb: (sel) => {
                                                                if (sel === "formMap") {
                                                                    addModalType({
                                                                        cls: "SearchMapModal", arg: {
                                                                            cb: (pot) => {
                                                                                console.log("pot", pot)
                                                                                //set_pot(pot);
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                else if (sel === "exitsList") {
                                                                    addModalType({
                                                                        cls: "OpenPotList", arg: {
                                                                            cb: () => {
                                                                            },
                                                                            type: "selPot"
                                                                        }
                                                                    })
                                                                }
                                                            }
                                                        }
                                                    })
                                                }}>
                                                    <YStyled.Col align="center">
                                                        <img src="./assets/ui/Location_b.png"></img>
                                                        <YStyled.Span size={13} >加入地點</YStyled.Span>
                                                    </YStyled.Col>
                                                </YStyled.Label>
                                            }

                                            <YStyled.Row style={{ margin: "1.4rem 0" }}>
                                                <YStyled.Span size={17} >野放模式</YStyled.Span>
                                            </YStyled.Row>
                                            <SelRewildingMode initSelectIndex={() => {
                                                const findIndex = AppConfig.modeEnum.findIndex(v => v.id === data.events_type);
                                                return findIndex;
                                            }} onSelect={typeObj => {
                                                set_data(prev => { return { ...prev, events_type: typeObj.id } })
                                            }} />
                                            <YStyled.Row style={{ marginTop: "1.4rem" }}>
                                                <YStyled.Span size={17} >時間</YStyled.Span>
                                            </YStyled.Row>
                                            <YStyled.VPanel align="center" style={{ marginTop: "1rem" }}>
                                                <DateTimeSel label={"開始"} initDate={data.events_date} onSelect={date => {
                                                    set_data(prev => { return { ...prev, events_date: date } })
                                                }} />
                                                <YStyled.Hr height=".5rem" />
                                                <DateTimeSel label={"結束"} initDate={data.events_date_end} onSelect={date => {
                                                    set_data(prev => { return { ...prev, events_date_end: date } })
                                                }} />
                                            </YStyled.VPanel>
                                            <YStyled.VPanel align="center" style={{ marginTop: "1rem" }}>
                                                <DateTimeSel timeEnabled={false} initDate={data.events_deadline} label={"報名截止日"} onSelect={date => {
                                                    set_data(prev => { return { ...prev, events_deadline: date } })
                                                }} />
                                                {/*<YStyled.Hr height=".5rem" />
                                        <YStyled.Row align="space-between">
                                            <YStyled.Span size={17} fontWeight={0}>費用</YStyled.Span>
                                            <YStyled.Row gap=".4rem" align="center" style={{ width: "auto" }}>
                                                <YStyled.Label style={{ background: "#F8F8F8", padding: ".4rem 2rem" }}>
                                                    <YStyled.Input value={data.events_payment_fee} onChange={e => {
                                                        set_data(prev => { return { ...prev, events_payment_fee: e.target.value } })
                                                    }} size={17} style={{ width: "4rem", textAlign: "center" }}></YStyled.Input>
                                                </YStyled.Label>
                                                <YStyled.Span size={17} fontWeight={0}>元</YStyled.Span>
                                            </YStyled.Row>
                                        </YStyled.Row> */}
                                            </YStyled.VPanel>
                                            <MemberLimit set_data={set_data} data={data} />
                                            <YStyled.Row style={{ margin: "1.4rem 0 1rem 0" }}>
                                                <YStyled.Span size={17} >集合點</YStyled.Span>
                                            </YStyled.Row>
                                            <MeetPoint meetPlace={meetPlace} set_meetPlace={set_meetPlace} rewildingObj={data.rewildingObj} type={0} placeholder={meetPlace.name} />

                                            <YStyled.RoundedDiv style={{ width: "100%", marginTop: "1rem" }}>
                                                <MapRoute origin={meetPlace} destination={{ lat: data.events_lat, lng: data.events_lng }} showBtn={true} />
                                            </YStyled.RoundedDiv>
                                            <YStyled.Row style={{ margin: "1.4rem 0 1rem 0" }}>
                                                <YStyled.Span size={17} >誰可以查看活動邀請</YStyled.Span>
                                            </YStyled.Row>
                                            <YStyled.Col gap="2rem" style={{ padding: "1rem" }}>
                                                <YStyled.Row gap=".4rem" align="space-between" onClick={e => {
                                                    set_data(prev => { return { ...prev, events_requires_approval: 0 } })
                                                }}>
                                                    <YStyled.Col gap=".4rem">
                                                        <YStyled.Span size={17} fontWeight={400}>所有朋友</YStyled.Span>
                                                        <YStyled.Span size={15} fontWeight={200}>朋友能在探索頁面看到此活動</YStyled.Span>
                                                    </YStyled.Col>
                                                    {data.events_requires_approval === 0 ?
                                                        <RadioButtonCheckedIcon />
                                                        : <RadioButtonUncheckedIcon />
                                                    }
                                                </YStyled.Row>
                                                <YStyled.Row gap=".4rem" align="space-between" onClick={e => {
                                                    set_data(prev => { return { ...prev, events_requires_approval: 1 } })
                                                }}>
                                                    <YStyled.Col gap=".4rem">
                                                        <YStyled.Span size={17} fontWeight={400}>擁有連結的人</YStyled.Span>
                                                        <YStyled.Span size={15} fontWeight={200}>知道邀請函連結的人可以申請加入</YStyled.Span>
                                                    </YStyled.Col>
                                                    {data.events_requires_approval === 1 ?
                                                        <RadioButtonCheckedIcon />
                                                        : <RadioButtonUncheckedIcon />
                                                    }
                                                </YStyled.Row>
                                            </YStyled.Col>

                                            <YStyled.Row style={{ margin: "1.4rem 0 1rem 0" }}>
                                                <YStyled.Span size={17} >成員</YStyled.Span>
                                            </YStyled.Row>
                                            <div className={styleUi.users}>
                                                {participants.map((v, k) => {
                                                    console.log("v", v)
                                                    return <YStyled.Row gap="1rem" align="flex-start">
                                                        <FriendInfo key={k} type={3} user={v.event_participants_user_detail} />
                                                        {v.event_participants_status_label === "PENDING" &&
                                                            <>
                                                            <YStyled.Label style={{ padding: ".2rem .6rem", borderRadius: "4px" }}><YStyled.Span color="#888" size={13}>邀請中</YStyled.Span></YStyled.Label>
                                                            <img src="./assets/ui/x.png" style={{marginLeft: "auto"}} onClick={e => {
                                                                apiManager.fetchDelete(`event/${data.events_id}/participants/${v.event_participants_id}`, {}, 0).then(res => {
                                                                    set_participants(prev=>prev.filter(vv=>vv.event_participants_id!==v.event_participants_id));
                                                                })
                                                            }} /></>
                                                        }
                                                    </YStyled.Row>
                                                })}
                                                {/* <div className={styleUi.userItem}>
                                            <FriendInfo type={4} />
                                            <img src="./assets/ui/x.png"></img>
                                        </div> */}
                                            </div>
                                            <YStyled.BTN2 style={{ width: "100%", marginTop: "1.4rem" }} onClick={e => {
                                                apiManager.fetchDelete(`event/${data.events_id}`, {}, 0).then(res => {
                                                    console.log(res);
                                                    arg.cb("remove");
                                                    setInProp(false);
                                                    if (arg.set_events) {
                                                        arg.set_events(prev => prev.filter(v => v.events_id !== data.events_id))
                                                    }
                                                })
                                            }}>
                                                <YStyled.Span size={17} fontWeight={400}>刪除此行程</YStyled.Span>
                                            </YStyled.BTN2>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}
const TitleBar = ({ data, identity, userData, participants, addModalType, set_isSetting, setInProp }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (<div className={styleUi.title}>
        <span></span>
        <YStyled.Row style={{ marginTop: "1.4rem" }}>
            <YStyled.Span size={22} >{data.events_name}</YStyled.Span>
        </YStyled.Row>
        {(identity.state === 0 || identity.state === 1) &&
            <img src="./assets/ui/more.png" onClick={e => {
                setAnchorEl(e.currentTarget);
            }} />
        }
        {(identity.state === 2 || identity.state === 3) &&
            <img src="./assets/ui/Share.png" onClick={async (e) => {
                const currentDomain = window.location.origin; // 获取当前的域名和协议，例如 "http://localhost:3000"
                const invitePath = `?type=eventInfo&id=${data.events_id}`; // 你想要生成的路径
                const inviteLink = `${currentDomain}${invitePath}`;
                if (navigator.share) {
                    try {
                        await navigator.share({
                            title: data.events_name,
                            text: 'OOSA',
                            url: inviteLink // 你想要分享的网址
                        });
                        console.log('分享成功');
                    } catch (error) {
                        navigator.clipboard.writeText(inviteLink).then(() => {
                            alert('己複製連結');
                        }).catch(err => {
                            console.error("複製到剪貼簿失敗：", err);
                        });
                    }
                }
            }} />
        }
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={e => { setAnchorEl(null); }}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            slotProps={{
                paper: {
                    className: styleUi.titlePopover,
                },
            }}
        >
            {
                (identity.state === 1) &&
                <YStyled.Row gap=".4rem" style={{ marginTop: ".1rem" }} onClick={e => {
                    const target = participants.find(v => v.event_participants_user === userData.users_id);
                    if (target) {
                        apiManager.fetchDelete(`event/${data.events_id}/participants/${target.event_participants_id}`, {}, 0).then(res => {
                            console.log("res", res);
                            setInProp(false);
                        })
                    }
                }}>
                    <YStyled.Span size={15} >退出</YStyled.Span>
                    <ExitToAppIcon />
                </YStyled.Row>
            }
            {
                (identity.state === 0) &&
                <>
                    <YStyled.Row gap=".4rem" style={{ marginTop: ".1rem" }} onClick={async (e) => {
                        setAnchorEl(null);
                        addModalType({
                            cls: "NewEvent", arg: {
                                pot: data.rewildingObj,
                                vo: data,
                                cb: () => {

                                }
                            }
                        })
                    }}>
                        <YStyled.Span size={15} >複製</YStyled.Span>
                        <ContentCopyOutlinedIcon />
                    </YStyled.Row>
                    <YStyled.Hr />
                    <YStyled.Row gap=".4rem" style={{ marginTop: ".1rem" }} onClick={e => {
                        set_isSetting(p => !p)
                        setAnchorEl(null);
                    }}>
                        <YStyled.Span size={15} >設定</YStyled.Span>
                        <SettingsOutlinedIcon />
                    </YStyled.Row>
                </>
            }


        </Popover>
    </div>);
}







export default memo(EventDetail);